<template>
  <div></div>
</template>

<script>
import { formatTime } from "../utils/index";
import wx from "weixin-js-sdk";
import serivce from "@/utils/ajax";
export default {
  name: "GetUser",
  data() {
    return {
      code: "",
      access_token: "",
      openid: "",
      // 线上环境
      appid: "wxa36a3028bc07e666",
      // demo环境
      // appid: "wx49b90d4c8fdb7461",
    };
  },
  mounted() {
    this.appid = process.env.VUE_APP_BASE_APPID
    const vm = this;
    let data = {};
    data.companyId = this.getQueryVariable("ci");
    data.departmentId1 = this.getQueryVariable("pi");
    data.departmentId2 = this.getQueryVariable("di");
    data.companyName = this.getQueryVariable("cn");
    // data.companyId = this.getQueryVariable('companyId')
    // data.departmentId1 = this.getQueryVariable('parentId')
    // data.departmentId2 = this.getQueryVariable('departmentId')
    // data.companyName = this.getQueryVariable('cpName')

    // if (!window.localStorage.getItem("openId")) {
      this.code = this.getUrlCode().code;
      if(this.code){
        serivce
        .get(`/api/lxUser/openid`, {
          code: this.code,
        })
        .then((res) => {
          console.log(res)
          if (res.status == 200) {
            let temp = JSON.parse(res.msg);
            data.access_token = temp.access_token;
            data.openid = temp.openid;
            localStorage.setItem("refresh_token", data.refresh_token);
            localStorage.setItem("access_token", data.access_token);
            localStorage.setItem("openid", data.openid);
            vm.wxConfig();
            vm.$router.push({
              path: "/AddUser",
              query: data,
            });
          } else{
            this.$toast({
              type: "fail",
              message: "网络异常，获取微信信息失败，请重新扫码。",
              className: "failLong",
              duration: 4000,
            });
          }
        });
      }else{
        this.getCode();
      }
    // } else {
    //   // 别的业务逻辑
    //   vm.wxConfig();
    // }
  },
  methods: {
    getCode() {
      var local = window.location.href;

      // demo用这个
      // var appid = "wx49b90d4c8fdb7461";
      // var secret = "ce5ac1b2746a367ddc480d06dbabefa7";

      // 线上用这个
      // var appid = "wxa36a3028bc07e666";
      // var secret = "3640c94d5c0fc74666b410dd9ce0d856";
      var appid = process.env.VUE_APP_BASE_APPID;
      var secret = process.env.VUE_APP_BASE_SECRET;
      // 截取code
      this.code = this.getUrlCode().code;
      if (this.code == null || this.code === "") {
        // 如果没有code，则去请求
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(
          local
        )}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`;
      } else {
        
      }
    },
    getUrlCode() {
      // 截取url中的code方法
      var url = location.search;
      this.winUrl = url;
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
        }
      }
      return theRequest;
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },
    wxConfig() {
      serivce
        .get("/api/lxUser/wxconfig", {
          appid: this.appid,
          url: window.location.href.split("#")[0],
        })
        .then((res) => {
          let data = res.data;
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: this.appid, // 必填，公众号的唯一标识
            timestamp: data.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.noncestr, // 必填，生成签名的随机串
            signature: data.signature, // 必填，签名，见附录1
            jsApiList: ["checkJsApi", "scanQRCode"], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
          
        });
    },
  },
};
</script>

<style>
</style>
